import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-type-field',
  templateUrl: './vehicle-type-field.component.html',
  styleUrls: ['./vehicle-type-field.component.scss']
})
export class VehicleTypeFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
